const staticText = {
  subtitle: (opening, email) => `${opening} we will need to verify your email address (${email}). If you experience an issue verifying your email, please |+|contact support@@mailto:support@smartcar.com|+| for help.`,
  btnSubmit: 'Send verification email',
};

export default staticText;
